// extracted by mini-css-extract-plugin
module.exports = {"block":"TextPage_block__1httR","wrapper":"TextPage_wrapper__2Z-qQ","contentActually":"TextPage_contentActually__3LWgL"};